import { apiContractedChangeCompany } from './api-contracted-changecompany';

export const ChangeCompanyActions = {
  api: {
    /** 契約会社操作権限 */
    contractedChangeCompany: apiContractedChangeCompany,
  },
};
